import AbstractGlobe from '@assets/abstract-globe.png';
import { usePublicEventContext } from '@event/contexts/PublicEventContext';
import { LanguageSpoken } from '@event/routes/public/EventDetail/EventDetailCard';
import { PublicWebinarEvent, RegistrationCardStatus } from '@event/types/event';
import TvIcon from '@mui/icons-material/Tv';
import { Typography } from '@mui/material';
import { toLogin } from '@utils/route';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

const EventDetailCardVirtual = () => {
    const {
        event: { data: anyEvent },
        isLoggedIn,
    } = usePublicEventContext();
    const event = anyEvent as PublicWebinarEvent;

    return (
        <>
            <div className="relative">
                <div className="absolute top-1/2 left-4 translate-y-[-50%] flex items-center gap-1">
                    <TvIcon color="white" />
                    <Typography component="span" fontSize={14} fontWeight={700} color="white.main">
                        <FormattedMessage id="event.virtual.uppercase" defaultMessage="VIRTUAL EVENT" />
                    </Typography>
                </div>
                <img src={AbstractGlobe} className="md:rounded h-[88px] w-full" />
            </div>
            {event.language_spoken ? <LanguageSpoken className="mt-5" /> : null}
            <div className="mt-4 px-3.5 md:px-0">
                <Typography fontWeight={700} fontSize={14} color="neutral-900.main">
                    <FormattedMessage id="event.roomUrl.uppercase" defaultMessage="ROOM URL" />
                </Typography>
                {event?.room_url ? (
                    event.registration_status === RegistrationCardStatus.REGISTERED ? (
                        <Typography
                            fontWeight={700}
                            fontSize={14}
                            color="primary"
                            marginTop="10px"
                            component={isLoggedIn ? 'a' : Link}
                            href={isLoggedIn ? event.room_url ?? '' : toLogin()}
                            target={isLoggedIn ? '_blank' : '_self'}
                        >
                            <FormattedMessage
                                id="event.clickToMeetingRoom"
                                defaultMessage="Click to go to the meeting room"
                            />
                        </Typography>
                    ) : (
                        <Typography fontSize={14} color="neutral-900.main" marginTop="10px">
                            <FormattedMessage
                                id="event.onlyRegisteredGuests"
                                defaultMessage="Only registered guests can view the meeting room link."
                            />
                        </Typography>
                    )
                ) : (
                    <Typography fontSize={14} color="neutral-900.main" marginTop="10px">
                        <FormattedMessage
                            id="event.meetingRoomLinkUnavailable"
                            defaultMessage="The meeting room link will be available soon."
                        />
                    </Typography>
                )}
            </div>
        </>
    );
};

export { EventDetailCardVirtual };
